
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRoofColourOn as ObiLightRoofColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-roof-colour-on.js';
 
 
 

 
 export const ObiLightRoofColourOn = createComponent({
   react: React,
   tagName: 'obi-light-roof-colour-on',
   elementClass: ObiLightRoofColourOnElement,
   events: {
     
   }
  });
 
 